// © Microsoft Corporation. All rights reserved.

import { defaultForceExpirationTimeMs, locationHref } from "./Constants";

import { localStorage } from "@msnews/core";

/**
 * Force timestamp prefix for render cache dom
 */
const forceTimestampPrefix = `force_timestamp_`;

/**
 * Force timestamp key for render cache dom
 */
export const forceStorageTimestampKey = `${forceTimestampPrefix}${locationHref}`;

/**
 * Function to determine if cache refresh should be forced.
 * Used as failsafe to force refresh of Render cache in case of corrupted render cache loop.
 * @param expirationTimeConfig Expiration time from render cache config
 * @returns true if we need to force refresh of cache.
 */
export function IsForceTimestampExpired(expirationTimeConfig: number): boolean {
    const expirationTime = expirationTimeConfig || defaultForceExpirationTimeMs;
    const currentTimestamp: number = new Date().getTime();
    const forceTimestamp = localStorage.getItem(forceStorageTimestampKey);
    const parsedForceTimestamp = forceTimestamp && parseInt(forceTimestamp);

    if (!parsedForceTimestamp) {
        localStorage.setObject(forceStorageTimestampKey, currentTimestamp);
        return false;
    }

    if ((currentTimestamp - parsedForceTimestamp) < expirationTime) {
        return false; // Force Cache Timestamp is valid.
    }

    return true; // Force Cache Timestamp expired.
}